import React from 'react'

function OpeningList({ Data }) {
    return (
        <div className="card h-100 mb-0">
            <div className="card-body">
                <h6 className="dash-sub-head">Job Openings List</h6>
                <div className='table-responsive mt-2 analytics-div  table-overflow'>
                    <table className='table table-striped'>
                        <thead>
                            <tr>
                                <th style={{ width: '50%', minWidth: '150px' }}>Job Title</th>
                                <th style={{ width: '6.66%', minWidth: '30px' }}>Positions</th>
                                <th style={{ width: '16.66%', minWidth: '100px' }}>Start Date</th>
                                <th style={{ width: '16.66%', minWidth: '100px' }}>End Date</th>
                                <th style={{ width: '16.66%', minWidth: '100px' }}>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Data && Data.length > 0 ? (
                                Data.map((job, index) => (
                                    <tr key={index}>
                                        <td>{job.summary}</td>
                                        <td>{job.no_of_position}</td>
                                        <td>{new Date(job.start_date).toLocaleDateString()}</td>
                                        <td>{new Date(job.end_date).toLocaleDateString()}</td>
                                        <td>
                                            <div className={`status-bar ${job.status === 'Open' ? 'status-green' : job.status === 'On Hold' ? 'status-yellow' : 'status-red'}`}>
                                                {job.status}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4">No job openings available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default OpeningList